<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="text-white">
        <TopBar />
      </q-header>
      <q-page-container>
        <div
          id="wrapper"
          class="full-width full-height background"
          :style="{
            backgroundImage:
              'url(' +
              require('@/assets/img/dinapsis-logo-background.svg') +
              '), linear-gradient(to bottom, rgba(244, 249, 250, 0.59) 13%, rgba(1, 17, 79, 0.59) 89%)'
          }"
        >
          <q-page :style-fn="myTweak">
            <div
              id="container"
              class="col-12 row full-width full-height"
              style="display: flex"
            >
              <div class="col-4 container-left full-height" style="">
                <div class="caja-superior">
                  <div class="title">{{ textTitle }}</div>
                  <div class="subtitle">{{ textSubtitle }}</div>
                </div>
                <div class="caja-lista">
                  <div class="title">{{ listTitle }}</div>
                  <div class="lista">
                    <ul>
                      <list-component-error
                        v-for="errorItem in listErrorComponent"
                        :key="errorItem.id"
                        :data="errorItem"
                      />
                    </ul>
                  </div>
                </div>
              </div>
              <div
                class="col-8 full-height"
                style="position: relative; overflow: hidden"
              >
                <div
                  class=""
                  style="
                    height: 100%;
                    position: absolute;
                    width: 100%;
                    bottom: 0 !important;
                    left: 15%;
                    top: 20%;
                  "
                >
                  <q-img
                    contain
                    height="100%"
                    :src="require('@/assets/img/ilustracion-404.svg')"
                    :img-style="{
                      alignSelf: 'flex-end',
                      paddingBottom: 0,
                      backgroundSize: 'none',
                      backgroundPosition: 'none'
                    }"
                  />
                </div>
              </div>
            </div>
          </q-page>
        </div>
      </q-page-container>
    </q-layout>
  </div>
</template>

<script>
import ListComponentError from './ListErrorComponent.vue';
import { QLayout, QPageContainer, QPage, QImg, QHeader } from 'quasar';
import TopBar from '../../top-bar/components/TopBar.vue';

export default {
  name: 'ErrorPage',
  components: {
    QLayout,
    QPageContainer,
    QPage,
    QImg,
    ListComponentError,
    QHeader,
    TopBar
  },
  props: {
    textTitle: {
      type: String,
      required: false,
      default: 'Oops!'
    },
    textSubtitle: {
      type: String,
      required: false,
      default: 'Error inesperado.'
    },
    listTitle: {
      type: String,
      required: false,
      default: 'Prueba alguno de estos enlaces:'
    },
    listErrorComponent: {
      type: Array,
      required: false
    }
  },
  created () {
    if (!this.$store.getters['PF/isLoggedIn']) {
      this.$router.push({ name: 'Default' });
    }
  },
  methods: {
    myTweak (offset) {
      var littleScreen = { minHeight: '150vh', height: '150vh' };
      var bigScreen = {
        minHeight: offset ? `calc(100vh - ${offset}px)` : '100vh',
        height: offset ? `calc(100vh - ${offset}px)` : '100vh'
      };

      var isLittleScreen = window.innerHeight <= 800;

      return isLittleScreen ? littleScreen : bigScreen;
    }
  }
};
</script>
<style lang="scss" scoped>
#wrapper {
  padding: 0px 0px 0px 100px !important;
}

.background {
  background-repeat: no-repeat;
  background-position: 2% bottom;
  background-size: auto auto, auto 80px;
}
.container-left {
  padding-top: 5%;
  .caja-superior {
    .title {
      font-family: DINPro;
      font-size: 139px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #003f87;
    }

    .subtitle {
      font-family: DINPro;
      font-size: 33px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #003f87;
    }
  }
  .caja-lista {
    margin-top: 85px;
    .title {
      font-family: DINPro;
      font-size: 33px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #313b44;
    }
    .lista {
      margin-top: 30px;
      ul {
        padding-left: 0px !important;
        list-style-type: none;
        li {
          a {
            cursor: pointer;
            text-decoration: none;
            color: inherit;
          }
        }
      }
      font-family: DINPro;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #7a7a7a;
    }
  }
}
</style>
